import React, { useEffect, useRef } from "react";

const RoundSlider = ({
  progress,
  width = 310 - 75,
  height = 310 - 75,
  showKnob = true,
  color = "#609af8",
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Set a higher resolution by increasing the canvas dimensions
    const scale = 3; // Scale factor for higher resolution
    const canvasSize = 150 * scale;
    canvas.width = canvasSize;
    canvas.height = canvasSize;

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = 60 * scale;

    // Define the arc range to cover 90% of a circle
    const totalAngle = 0.85 * 2 * Math.PI; // 90% of a full circle
    const startAngle = Math.PI / 1.55; // Start at the top of the circle
    const endAngle = startAngle + totalAngle * (progress / 100); // Progress based on 90% arc

    // Clear previous drawing
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background arc
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, startAngle, startAngle + totalAngle);
    ctx.strokeStyle = "#DFE7EF";
    ctx.lineWidth = 10 * scale;
    ctx.stroke();

    // Progress arc
    if (progress > 0) {
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, startAngle, endAngle);
      ctx.strokeStyle = color; // Progress color
      ctx.lineWidth = 10 * scale;
      ctx.lineCap = "round"; // Rounded ends for the progress line
      ctx.stroke();
    }

    if (showKnob) {
      // Knob at the end of the progress arc
      const knobX = centerX + radius * Math.cos(endAngle);
      const knobY = centerY + radius * Math.sin(endAngle);

      ctx.beginPath();
      ctx.arc(knobX, knobY, 10 * scale, 0, 2 * Math.PI); // Small circle for the knob
      ctx.fillStyle = "#326FD1"; // Knob color
      ctx.fill();
    }

    // Add percentage text
    const percentage = Math.round(progress);
    const fontSize = (width < 100 ? 35 : 20) * scale;
    ctx.font = `${fontSize}px Arial`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    ctx.shadowColor = "#3B82F633"; // Shadow color as the same as progress color
    ctx.shadowBlur = 8; // Shadow blur level
    ctx.shadowOffsetX = 0; // Shadow horizontal offset
    ctx.shadowOffsetY = 4; // Shadow vertical offset

    // Draw background circle for percentage text
    const textBackgroundRadius = (width < 100 ? 0 : 40) * scale; // Background radius for the text
    ctx.beginPath();
    ctx.arc(centerX, centerY, textBackgroundRadius, 0, 2 * Math.PI);
    ctx.fillStyle = "#F5F9FF"; // White background for text
    ctx.fill();

    // Reset shadow for text drawing
    ctx.shadowColor = "transparent";

    // Draw the percentage text
    ctx.fillStyle = "#183462"; // Text color
    ctx.fillText(`${percentage || 0}%`, centerX, centerY);

    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
  }, [progress, width, height, color, showKnob]); // Redraw whenever progress changes

  return (
    <div className="flex justify-content-center align-items-center">
      <canvas ref={canvasRef} width={width} height={height} />
    </div>
  );
};

export default RoundSlider;
